// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
    width: 100%;
    background-color: #333; 
    color: white;
    font-size: 16px;
}

.nav-links {
    display: flex;
    justify-content: flex-start; 
}

.nav-link {
    padding: 1rem 2rem; 
    text-decoration: none;
    color: white;
    border-right: 1px solid #fff;
}

.nav-link:last-child {
    border-right: none; 
}

.nav-link:hover {
    background-color: #494747;
}`, "",{"version":3,"sources":["webpack://./src/Nav.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".navbar {\n    width: 100%;\n    background-color: #333; \n    color: white;\n    font-size: 16px;\n}\n\n.nav-links {\n    display: flex;\n    justify-content: flex-start; \n}\n\n.nav-link {\n    padding: 1rem 2rem; \n    text-decoration: none;\n    color: white;\n    border-right: 1px solid #fff;\n}\n\n.nav-link:last-child {\n    border-right: none; \n}\n\n.nav-link:hover {\n    background-color: #494747;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
